import React from 'react'
import styled from 'styled-components'
import { GreySection } from '../../../../components/section'
import { SectionTitle } from '../atom'
import { Row, Col, media } from 'styled-bootstrap-grid'

const Card = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  background: rgba(255, 255, 255, 1);
  color: #333333;
  border-radius: 4px;
  font-size: 20px;
  > img {
    width: 30px;
    height: 30px;
    margin-right: 18px;
  }
  ${media.max.md`
    font-size: 10px;
    height: 42px;
    > img {
      margin-right: 8px;
      width: 15px;
      height: 15px;
    }
  `}
`
const FeatureCol = styled(Col)<{ type: string }>`
  margin-bottom: 30px;
  max-width: ${p => (p.type === '3d' ? '50%' : '33%')};
  ${media.max.md`
    margin-bottom: 15px;
  `}
`

const BaseContent = styled.div`
  max-width: 1200px;
  margin: auto 40px;
  ${media.max.md`
    margin: auto 0;
  `}
`
export interface ScenceProps {
  menuData: any
  type: string
}

export function Scence(props: ScenceProps) {
  const { menuData, type } = props
  return (
    <GreySection>
      <SectionTitle>应用场景</SectionTitle>
      <BaseContent>
        <Row>
          {menuData.map((item: any) => (
            <FeatureCol col={item.col} md={item.md} type={type}>
              <Card>
                <img src={item.icon} alt='' />
                {item.title}
              </Card>
            </FeatureCol>
          ))}
        </Row>
      </BaseContent>
    </GreySection>
  )
}
